import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Logo from "../sharable/Logo";
import { Modal, ModalHeader } from "../../SharableStyles/FormStyle";
import { IonIcon } from "@ionic/react";
import { code, mailOpenOutline, mailOutline } from "ionicons/icons";
import { Input } from "../sharable/InputStyle";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import Button from "../sharable/ActionButton";
import Loading from "../sharable/Loading";
import FormMessage from "../sharable/FormMessage";
import { use } from "react";
import useFormValidation from "../sharable/hooks/useFormValidation";
import Help from "../sharable/Help";
import { devices } from "../../Devices";
const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
const Container = styled.div`
  width: 100vw;
  height: min-content;
  min-height: 100vh;
  padding: 2.4rem 4.8rem;
  background-image: url("images/cta-bg.png");
  background-size: cover;

  header {
    padding: 2rem 4.2rem;
    display: flex;
    justify-content: start;
    width: 100%;
  }

  @media ${devices.mobileL} {
    padding: 2.4rem 0;
  }
`;

const Main = styled.main`
  position: relative;
  padding: 2rem;
  gap: 3.2rem;
  .mail-icon {
    font-size: 10rem;
  }

  p {
    font-size: 1.2rem;
  }

  .wrapper {
    margin-top: 2rem;
  }

  .error-message {
    margin-top: 0.6rem;
    min-width: 100%;
  }
`;

export const requestValidationCodeNotification = async (email) => {
  const res = await fetch(`${BASE_URL}account-validation?email=${email}`);
  return res;
};

export default function EmailValidation() {
  const [searchParams] = useSearchParams();
  const [isCodeValidated, setIsCodeValidated] = useState(false);
  const [validationMessage, setValidationMessage] = useState(null);
  const { values, handleChange, validate, errors } = useFormValidation({
    code: {
      label: "código",
      required: true,
      minLength: 8,
      maxLength: 8,
      customMessages: {
        minLength: "Código deve ter 8 dígitos",
        maxLength: "Código deve apenas 8 dígitos",
      },
    },
  });
  const navigate = useNavigate();

  const getCodeFromSearchParam = useEffect(() => {
    const code = searchParams.get("code");
    if (code) {
      handleChange("code", code);
    }
  }, []);

  const validateCode = async () => {
    const res = await fetch(
      `${BASE_URL}account-validation?code=${
        values.code
      }&email=${searchParams.get("email")}`,
      {
        method: "POST",
      }
    );
    if (res.ok) {
      setValidationMessage({
        type: "success",
        message:
          "Sua conta foi validada com sucesso ;). Aguarde, logo você será redirecionado",
      });
      setTimeout(() => {
        navigate("/encartes");
      }, 5000);
    } else if (res.status === 401) {
      setIsCodeValidated(true);
      setValidationMessage({
        type: "error",
        message: "Código inválido ou expirado",
      });
    }
  };

  return (
    <Container>
      <header>
        <Logo
          color={"white"}
          size={12}
          navigable={true}
          showGoBackButton={true}
          path={"/encartes"}
        />
      </header>
      <Modal className="modal">
        <ModalHeader>
          <h1>Verifique seu email!</h1>
          <p>Pode levar até 5 minutos para o código chegar no seu email</p>
        </ModalHeader>

        <Main className="flex">
          <IonIcon icon={mailOpenOutline} className="mail-icon" />
          <div className="content">
            <>
              <h2>Enviamos o código no seu email</h2>
              <p>
                Digite o código que você recebeu no seu email no campo abaixo
              </p>
              <div className="flex error-message">
                {validationMessage?.type === "error" && (
                  <FormMessage message={validationMessage.message} />
                )}

                {validationMessage?.type === "success" && (
                  <FormMessage
                    message={validationMessage.message}
                    type="success"
                  />
                )}
              </div>

              <div className="wrapper flex min-gap direction-column">
                <Input
                  defaultValue={values.code}
                  placeholder="Cole o código aqui"
                  onInput={(e) => handleChange("code", e.target.value)}
                />
                {errors.code &&
                  errors.code.map((msg, i) => (
                    <FormMessage
                      message={msg}
                      key={i}
                      backgroundColor="transparent"
                      align="left"
                    />
                  ))}
                {!isCodeValidated && (
                  <Button
                    text={"Validar código"}
                    action={() => {
                      if (validate()) validateCode();
                    }}
                  />
                )}
              </div>
            </>
          </div>
        </Main>
      </Modal>
      <Help color={"white"} />
    </Container>
  );
}
